import { createSlice } from "@reduxjs/toolkit"
import { moveNote, openToPath, pasteCopy } from "./workspaceNoteSlice"
import { attachArticlesToNote } from "./breadcrumbSlice"

const initialValue = { id: null, path: [] }

export const targetNoteSlice = createSlice({
	name: "targetNote",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		setTargetNote: (state, action) => {
			const { workspaceId, note } = action.payload
			state.byWorkspace[workspaceId] = note
		},
		clearTargetNote: (state, action) => {
			const { workspaceId } = action.payload
			state.byWorkspace[workspaceId] = initialValue
		},
	},
	extraReducers: (builder) => {
		builder.addCase(pasteCopy.fulfilled, (state, action) => {
			const { note } = action.payload
			if ( note ) {
				state.byWorkspace[note.workspaceId] = note
			}
		})
		builder.addCase(openToPath.fulfilled, (state, action) => {
			const { note, fromWebsocket } = action.payload
			const { workspaceId } = action.payload
			if (!fromWebsocket) {
				state.byWorkspace[workspaceId] = note
			}
		})
		builder.addCase(attachArticlesToNote.fulfilled, (state, action) => {
			const {workspaceId, note} = action.payload
			// if there is currently no target note set, set it to the note the cite was attached to
			if(!state.byWorkspace[workspaceId]?.id) {
				state.byWorkspace[workspaceId] = note
			}
		})
		builder.addCase(
			moveNote.fulfilled,
			(state, action) => {
				const { workspaceId } = action.meta.arg
				const {newNote} = action.payload
				state.byWorkspace[workspaceId] = newNote
			}
		)
	},
})

export const { setTargetNote, clearTargetNote } = targetNoteSlice.actions

const EMPTY_TARGET = Object.freeze({ id: null, path: [] })
export const selectTargetNote = (state, workspaceId) => state.targetNote.byWorkspace[workspaceId] ?? EMPTY_TARGET

export default targetNoteSlice.reducer
